import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
export function useOneTimePinState(onResend, resendAvailableAt) {
    const navigate = useNavigate();
    const [remainingSeconds, setRemainingSeconds] = useState(0);
    const [isResending, setIsResending] = useState(false);
    const { control, formState: { errors, isValid }, handleSubmit: submitForm, register, } = useForm({
        mode: "all",
        defaultValues: {
            pin: "",
        },
    });
    const canSubmit = useMemo(() => !!isValid, [isValid]);
    const handleBackClicked = useCallback(() => {
        navigate(-1);
    }, [navigate]);
    useEffect(() => {
        function updateRemainingSeconds() {
            setRemainingSeconds(Math.max(0, Math.ceil(((resendAvailableAt ?? 0) - Date.now()) / 1000)));
        }
        updateRemainingSeconds();
        const interval = window.setInterval(updateRemainingSeconds, 1000);
        return () => window.clearInterval(interval);
    }, [resendAvailableAt]);
    const handleResend = useCallback(async () => {
        if (!onResend || remainingSeconds > 0 || isResending) {
            return;
        }
        setIsResending(true);
        try {
            await onResend();
        }
        finally {
            setIsResending(false);
        }
    }, [isResending, onResend, remainingSeconds]);
    register("pin", {
        required: { value: true, message: "Please enter the verification code" },
        pattern: { value: /^\d{6}$/, message: "Enter the complete 6-digit verification code" },
    });
    return useMemo(() => ({
        control,
        canSubmit,
        handleBackClicked,
        handleResend,
        isResending,
        remainingSeconds,
        submitForm,
    }), [control, canSubmit, handleBackClicked, handleResend, isResending, remainingSeconds, submitForm]);
}
